/**
 * DebugOverlay.ts — a lightweight on-screen dev readout (FPS, frame time, draw
 * calls, seed, etc.). Meant for development; can be toggled off for players.
 */
export class DebugOverlay {
  private el: HTMLDivElement;
  private frames = 0;
  private elapsed = 0;
  private fps = 0;
  private lines: Record<string, string> = {};

  constructor(parent: HTMLElement = document.body) {
    this.el = document.createElement('div');
    this.el.className = 'debug-overlay';
    parent.appendChild(this.el);
  }

  /** Call once per rendered frame with the frame delta in seconds. */
  tick(frameDt: number): void {
    this.frames++;
    this.elapsed += frameDt;
    // Refresh the DOM twice a second (avoids layout thrash every frame).
    if (this.elapsed >= 0.5) {
      this.fps = this.frames / this.elapsed;
      this.frames = 0;
      this.elapsed = 0;
      this.render();
    }
  }

  /** Set or update a named readout line, e.g. set('seed', 12345). */
  set(key: string, value: string | number): void {
    this.lines[key] = typeof value === 'number' ? String(Math.round(value)) : value;
  }

  private render(): void {
    const body = Object.entries(this.lines)
      .map(([k, v]) => `${k.padEnd(7)} ${v}`)
      .join('\n');
    this.el.textContent = `fps     ${Math.round(this.fps)}\n${body}`;
  }

  setVisible(visible: boolean): void {
    this.el.style.display = visible ? '' : 'none';
  }

  dispose(): void {
    this.el.remove();
  }
}
